import { KYMW4701Model } from '../kymw4701.model';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

export type RegistMultiGoodsResponse = {
  MultiGoodsList: {
    MultiCode: string;
    CommonCatchcopy: string;
    CommonGoodsExplanation: string;
    PublishSeq: string;
    PCode: string;
    ApplyTermEnd: string;
    GuideGoodsName: string;
    GuideStandardName: string;
    MakerName: string;
    PayeeClient: string;
    RegistDate: string;
  }[];
};

/**
 * マルチ商品情報登録
 *
 * @export API通信成功時の処理
 * @class RegistMultiGoodsService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class RegistMultiGoodsService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW4701Model = null;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistMultiGoodsService
   */
  private getBody(): PlessRequest {
    const combi = this.model.multiGoodsList.map(_ => ({
      parameter: { PublishSeq: _.PublishSeq, PCode: _.PCode },
    }));

    return new PlessRequest({
      regist: {
        MultiGoodsInfo: {
          parameter: {
            MultiCode: this.model.multiCode,
            CommonCatchcopy: this.model.commonCatchcopy,
            CommonGoodsExplanation: this.model.commonGoodsExplanation,
          },
          combination: combi,
        },
      },
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW4701Model} model
   * @param {Function} [successFunc] 成功時後続処理
   * @memberof RegistMultiGoodsService
   */
  execute(model: KYMW4701Model, successFunc: Function = null) {
    this.model = model;
    this.successFunc = successFunc;
    this.send('registMultiGoods', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof RegistMultiGoodsService
   */
  success(data: RegistMultiGoodsResponse) {
    if (data) this.model.setMultiGoodsData(data);
    if (this.successFunc) this.successFunc();
  }
}
